import React from 'react';
import { motion } from 'framer-motion';
const painPoints = ['Sunday nights lost trying to explain the difference between a hypothesis, a research question and an objective in a way that actually makes sense in the classroom', 'Lessons that feel disconnected — because you are covering topics without a clear progression that ties them together', 'Students who arrive at the final project without understanding the full research process — because there was never a sequence that guided them step by step', 'Visible improvisation that quietly chips away at your confidence as a teacher, especially on the most technical topics', 'Weekends spent planning instead of resting, recovering or living your life', 'No real progression — just a collection of disconnected activities that never build a competent researcher'];
export function PainPoints() {
  return <section className="py-24 px-4 bg-black" data-id="element-132" data-mp="3nco0yb4h1ogc">
      <div className="max-w-3xl mx-auto" data-id="element-133" data-mp="3nbcz4gul6qrv">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-134" data-mp="3nablq5q3ls6z">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-135" data-mp="1tzrbmi0tn5gd">Does This Sound Familiar?</h2>
          <div className="text-lg text-gray-300 leading-relaxed bg-navy-card p-6 rounded-2xl border border-navy-border text-left" data-id="element-136" data-mp="27utc2pmwg2ls">
            <p data-id="element-137" data-mp="1g1atzw1f7ujg">
              Sunday night. 10 PM. You have Research Methods class tomorrow morning. And you are still there — trying to explain the difference between a research question and an objective, building a sampling activity that actually makes sense, and trying to create a sequence that feels professional instead of assembled in twenty minutes.
            </p>
            <p className="mt-6" data-id="element-138" data-mp="30hnwjmjpv1z9">
              <span className="text-gold-light font-medium" data-id="element-139" data-mp="30gux76n37er5">Not because you do not know research. Not because you are not a good teacher.</span>{' '}
              Because nobody ever gave you a complete, ready-to-teach system for guiding students through the entire research process from beginning to end.
            </p>
            <p className="mt-6" data-id="element-140" data-mp="1y2x5dagvey4d">
              You have been building every lesson from scratch: the theoretical framework guide, the variables activity, the qualitative analysis explanation, the example problem statement. Everything — every single week.
            </p>
            <p className="mt-6" data-id="element-141" data-mp="1afgiwogadxlc">
              The time you should be resting, you are spending it planning. And the worst part is walking into the classroom feeling like you could have been better prepared for a subject your students already find difficult.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-142" data-mp="1o73rnnrf0yl0">
          <h3 className="text-xl font-bold text-white mb-8 text-center" data-id="element-143" data-mp="vozj19javfqk">The Real Cost of Not Having the Right Resource:</h3>
          <ul className="space-y-4" data-id="element-144" data-mp="o4xd185ju7x3">
            {painPoints.map((point, index) => <motion.li key={point} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-navy-card p-4 rounded-xl border border-red-900/30" data-id="element-145" data-mp="j86xqn1kjgcq" data-mpi={index}>
                <span className="text-red-500 mt-1" aria-hidden="true" data-id="element-146" data-mp="gxma888mhii">●</span>
                <span className="text-gray-300" data-id="element-147" data-mp="eum4vddf802">{point}</span>
              </motion.li>)}
          </ul>
          <div className="text-center mt-12 pt-8 border-t border-navy-border" data-id="element-148" data-mp="3mnvrwv8b92vn">
            <p className="text-2xl font-serif font-bold text-gold-gradient" data-id="element-149" data-mp="3mm185k8rzgt5">Stop giving away your free time. Your dedication is already there. What you need now is the right tool.</p>
            <p className="text-xl mt-4 text-white" data-id="element-150" data-mp="3dnzb1fs5x8b5">Plan a full year of Research Methods classes today.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}